<template>
  <div>
    <strategio-app-bar></strategio-app-bar>
    <v-main style="height:100vh;padding-top:87px">
      <div style="max-height:100%; overflow:auto">
        <div class="strategio-iframe" id="reportContainer"></div>
      </div>
    </v-main>
  </div>
</template>

<script>
import StrategioAppBar from '../components/header-bar/strategio-app-bar.vue'
import reportsStorage from '../storage/reportsStorage'
import * as pbi from 'powerbi-client'
import uris from '../utils/uris'

export default {
  name: 'show-metabase',
  data () {
    return {
      url: uris.URL_POWERBI_ID
    }
  },
  components: {
    StrategioAppBar
  },
  methods: {
    loadReport () {
      reportsStorage.getAccessToken(this.url, (at) => {
        this.loadPowerBiFolder(this.url, at.accessToken)
      })
    },
    loadPowerBiFolder (rId, at) {
      // Report's Secured Token
      let accessToken = at

      // Embed URL
      const embedUrl = 'https://app.powerbi.com/reportEmbed?groupId=3ddccf9f-ba6a-4ce2-8f78-8a5e15cfb780'

      // Report ID
      const embedReportId = rId

      let models = pbi.models

      let config = {
        type: 'report',
        accessToken: accessToken,
        embedUrl: embedUrl,
        id: embedReportId,
        permissions: models.Permissions.All
      }

      // Grab the reference to the div HTML element that will host the report.
      let reportContainer = document.getElementById('reportContainer')

      // Embed the report and display it within the div container.
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      )
      let report = powerbi.embed(reportContainer, config)

      // Report.off removes a given event handler if it exists.
      report.off('loaded')

      // Report.on will add an event handler which prints to Log window.
      report.on('loaded', function () {
        // console.log('Loaded')
      })
    }
  },
  mounted () {
    this.loadReport()
  }
}
</script>

<style>
.strategio-iframe {
  width: 100%;
  height: 100%;
  position: absolute;
}
</style>


// WEBPACK FOOTER //
// src/routes/show-report-bi.vue